// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"f1eb3993","119":"8d940f77"}[chunkId] + ".chunk.js";
};